<template>
  <div class="baiduQueue">
    <div class="head">
      <img src="/static/index/index1.png" alt="" />
      <div class="h0">
        <div class="h1">工程师e家</div>
        <div class="h2">
          <div class="h21">
            <el-input v-model="input" @keyup.enter.native="search" placeholder="输入品牌/型号"></el-input>
          </div>
          <div class="h22" @click="search">查询</div>
        </div>
      </div>
    </div>
    <div class="b2">
      <div class="b21">
        <div :class="modelIndex == 0 ? 'b211' : ''" @click="updateModerIndex(0)">产品型号</div>
        <div :class="modelIndex == 1 ? 'b211' : ''" @click="updateModerIndex(1)">经销商</div>
        <div :class="modelIndex == 2 ? 'b211' : ''" @click="updateModerIndex(2)">应用视频</div>
        <div :class="modelIndex == 3 ? 'b211' : ''" @click="updateModerIndex(3)">故障视频</div>
        <div :class="modelIndex == 4 ? 'b211' : ''" @click="updateModerIndex(4)">品牌介绍</div>
      </div>
      <div class="b22" v-if="modelIndex == 0 && !instructions">
        <div @click="chooseSpec(item)" v-for="(item, index) in list" :key="index">
          <img :src="item.imageUrl" alt="">
          <div>
            <div class="b221">{{ item.wareName }}</div>
            <div class="b222">{{ item.content }}</div>
          </div>
        </div>
      </div>
      <div class="b23" v-if="modelIndex == 0 && instructions">
        <div class="b231" v-for="(item, index) in specList" :key="index">
          <img :src="item.fileType == 'pdf' ? pdfImg : item.fileType == 'doc' ? wordImg : imageImg" alt="">
          <div class="b2311">{{ item.itemKey }}说明书</div>
          <div class="b2312 b2313" @click.stop="view(item, 1)">查看</div>
          <div class="b2312" @click.stop="view(item, 2)" v-if="isDownload != 2">下载</div>
        </div>
        <div class="b232" @click="instructions = false">
          <img src="/static/index/index5.png" alt="">
          <div>返回</div>
        </div>
      </div>
      <div class="b23" v-if="modelIndex == 1">
        <div class="b231" v-for="(item, index) in agent" :key="index">
          <img :src="item.logoUrl ? item.logoUrl : '/static/index/index6.png'" alt="">
          <div class="b2311">{{ item.orgaName }}</div>
        </div>
      </div>
      <div class="b22" v-if="modelIndex == 2">
        <div @click="video(item)" v-for="(item, index) in list2" :key="index">
          <img :src="item.imageUrl" alt="">
          <div>
            <div class="b221">{{ item.wareName }}</div>
            <div class="b222">{{ item.content }}</div>
          </div>
        </div>
      </div>
      <div class="b22" v-if="modelIndex == 3">
        <div @click="video(item)" v-for="(item, index) in list3" :key="index">
          <img :src="item.imageUrl" alt="">
          <div>
            <div class="b221">{{ item.wareName }}</div>
            <div class="b222">{{ item.content }}</div>
          </div>
        </div>
      </div>
      <div class="b25" v-if="modelIndex == 4">
        <div class="web-url" v-if="webUrl">
          <span>官方网址：</span>
          <a :href="webUrl" target="_blank">{{ webUrl }}</a>
        </div>
        <img v-for="(item, index) in banner.split(',')" :src="item" :key="index" alt="">
        <!-- <div>
              <div class="b241">
                <img src="/static/index/index6.png" alt="">
                <div>济南华控科技有限公司</div>
              </div>
              <div class="b242">描述内容描述内容描述内容描述内容描述，内容描述内容描述内容描述内容描述。内容描述内容描述内容描述，内容描述内容描述，内容描述内容描述内容描述内容描述内容</div>
            </div> -->
      </div>
    </div>
    <el-dialog :title="videoTitle" :visible.sync="dialogVisible" width="50%" :before-close="no">
      <video autoplay controls style="width: 100%; height: 400px" :src="src"></video>
    </el-dialog>
    <el-dialog title="请选择以下充值方式" :visible.sync="dialogVisible2" width="760px" :before-close="no">
      <div class="imgShow">
        <div class="i1">
          <img src="/static/index/index19.png" alt="" />
          <div>工程师e家APP</div>
        </div>
        <div>
          <img src="/static/index/index18.png" alt="" />
          <div>工程师e家小程序</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookie from "js-cookie";

export default {
  title: "课程列表",
  data() {
    return {
      pdfImg:
        "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fwww.likeyunba.com%2Fpan%2Fres%2F1500320053.jpg&refer=http%3A%2F%2Fwww.likeyunba.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1611302694&t=2ff816eeb00c5f01c1b0f136aecf2e28",
      wordImg:
        "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fku.90sjimg.com%2Felement_pic%2F18%2F07%2F12%2F99d868145755a82fc42f856f0a7968c3.jpg&refer=http%3A%2F%2Fku.90sjimg.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1611302692&t=0c3c3c3b4db9e18d716d3ac3cfb1f7e3",
      imageImg:
        "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fbpic.588ku.com%2Felement_origin_min_pic%2F00%2F97%2F07%2F3156f313952d39b.jpg&refer=http%3A%2F%2Fbpic.588ku.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1611375698&t=3a4d1c41c976e8f24ad887af91ac8cd9",
      input: "", // 搜索产品输入
      state: false, // 是否显示所有产品类型
      instructions: false, //是否显示某个产品型号说明书
      modelIndex: 0, //产品型号 经销商 应用视频 故障视频 公司介绍切换
      typeId: 0,
      treeList: [],
      treeList_: [],
      list: [],
      list2: [],
      list3: [],
      agent: [],
      specList: [],
      isDownload: '',
      dialogVisible: false,
      dialogVisible2: false,
      videoTitle: "",
      src: "",
      price: "",
      page: 1,
      allPage: 0,
      webUrl: "",
    };
  },
  computed: {},
  components: {},
  mounted() {
    if (this.$route.query.item) {
      this.input = this.$route.query.item;
    }
    this.getData();
    this.$axios.post("/do_get_setting").then((res) => {
      for (let i = 0; i < res.data.data.length; i++) {
        if (res.data.data[i].itemKey == "download") {
          this.price = res.data.data[i].settingValue;
        }
      }
    });
  },
  methods: {
    search() {
      if (!this.input) {
        this.$message.error("请输入搜索内容");
        return;
      }
      this.$router.push({
        path: '/search',
        query: {
          item: this.input
        }
      })
    },
    no() {
      this.dialogVisible = false;
      this.dialogVisible2 = false;
      this.src = "";
    },
    view(e, index) {

      if (!Cookie.get("id")) {
        this.$message.error("请登录");
        return;
      }



      if (index == 2) {

        if (Cookie.get("level") > 0) {
          window.open(e.materials[0].imageUrl);
          return;
        }

        let params = {
          aid: Cookie.get("id"),
          access_token: sessionStorage.getItem('access_token')
        };
        this.$axios
          .post("/get_account_info", this.$qs.stringify(params))
          .then((res) => {
            if (res.data.errCode == 0) {
              // console.log(res.data.data)
              if (res.data.data.integral < Number(this.price)) {
                // this.$message.error(`下载当前文件需要花费${Number(this.price)}积分,你的积分不足，请充值`);
                this.dialogVisible2 = true;
                return;
              } else {
                this.$confirm(
                  `下载当前文件需要花费${Number(this.price)}积分，你当前积分为${res.data.data.integral
                  }。获取积分方式：1. 签到获取积分 2.小程序转发群和朋友圈获取积分`,
                  "提示",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                  }
                )
                  .then(() => {
                    this.$axios
                      .post(
                        `/download_file`,
                        this.$qs.stringify({ aid: Cookie.get("id") })
                      )
                      .then((res) => {
                        if (res.data.errCode == 0) {
                          // this.$router.push({
                          //   path:'/view',
                          //   query:{
                          //     url:e.materials[0].imageUrl,
                          //     index
                          //   }
                          // })
                          window.open(e.materials[0].imageUrl);
                        }
                      });
                  })
                  .catch(() => { });
              }
            }
          });
      } else {

        if (Cookie.get("level") <= 0) {
          this.$message.error("请购买会员");
          return;
        }

        if (e.fileType == "pdf") {
          this.$router.push({
            path: "/view",
            query: {
              url: e.materials[0].imageUrl,
              index,
            },
          });
        } else if (e.fileType == "doc") {
          window.open(
            "https://view.officeapps.live.com/op/view.aspx?src=" +
            e.materials[0].imageUrl,
            "_blank"
          );
        } else if (e.fileType == "png" || e.fileType == "jpg") {
          this.$router.push({
            path: "/pngView",
            query: {
              url: e.materials[0].imageUrl,
              index,
            },
          });
        }
      }

      // window.open(e.materials[0].imageUrl, "_blank");
    },
    video(e) {
      if (!Cookie.get("id")) {
        this.$message.error("请登录");
        return;
      }
      let params = {
        aid: Cookie.get("id"),
        wareId: e.wareId,
      };
      this.$axios
        .post("/do_check_video", this.$qs.stringify(params))
        .then((res) => {
          if (res.data.data.recordId > 0) {
            this.dialogVisible = true;
            this.videoTitle = e.wareName;
            this.src = e.specList[0].materials[0].imageUrl;
          } else {
            this.$message.error(
              "您没有此权限，请下载app或打开微信小程序购买视频或会员"
            );
            return;
          }
        });
    },
    chooseSpec(e) {
      this.$axios
        .post(`/get_product_detail`, this.$qs.stringify({ wareId: e.wareId }))
        .then((res) => {
          this.specList = res.data.data.specList;
          this.isDownload = res.data.data.isDownload;
          for (let i = 0; i < this.specList.length; i++) {
            this.specList[i].fileType =
              this.specList[i].materials[0].imageUrl.split(".")[
              (this.specList[i].fileType =
                this.specList[i].materials[0].imageUrl.split(".").length - 1)
              ];
          }
          this.instructions = true;
        });
    },
    //  产品型号 经销商 应用视频 故障视频 公司介绍切换
    updateTree(e) {
      this.typeId = e.typeId;
      this.getData(e.typeId);
    },
    updateModerIndex(e) {
      this.modelIndex = e;
      this.instructions = false;
    },
    // 是否显示所有产品类型
    updateState() {
      this.state = !this.state;
    },
    pageChange(e) {
      this.page = e;
      this.getData();
    },
    getData(e) {
      this.modelIndex = 0
      this.instructions = false
      this.list = []
      this.list2 = []
      this.list3 = []
      this.$axios.post('/get_ware_detail', this.$qs.stringify({ typeId: this.$route.query.id })).then(res => {
        let list = res.data.data.wareList
        for (let i = 0; i < list.length; i++) {
          if (list[i].specList[0].item.itemName == '视频') {
            this.list2.push(list[i])
          } else if (list[i].specList[0].item.itemName == '故障视频') {
            this.list3.push(list[i])
          } else {
            this.list.push(list[i])
          }
          // if(a.split('.')[a.split('.').length-1]=='pdf' || a.split('.')[a.split('.').length-1]=='PDF'){
          // 	this.list.push(list[i])
          // }else{
          // 	this.list2.push(list[i])
          // }
        }

        this.banner = res.data.data.banner
        this.webUrl = res.data.data.webUrl
        this.phone = res.data.data.telephone
      })
      let obj = {
        crud: 2,
        retailerJson: JSON.stringify({
          ids: this.$route.query.id
        })
      }
      this.$axios.post(`/do_oper_retailer`, this.$qs.stringify(obj)).then(res => {
        this.agent = res.data.data
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.imgShow {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 293px;
  border-top: 1px solid #cccccc;

  &>div {
    img {
      width: 168px;
      height: 168px;
      margin: 0 auto 16px;
    }

    div {
      font-size: 18upx;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #333333;
      text-align: center;
    }
  }

  .i1 {
    margin-right: 129px;
  }
}

.el-pagination {
  text-align: center;
  margin-top: 36px;
  margin-bottom: 50px;

  /deep/ .el-pager li,
  /deep/ .btn-next,
  /deep/ .btn-prev {
    background: transparent;
  }

  /deep/ .el-pager li:not(.disabled).active {
    border-radius: 50%;
    background: #88c0f8;
  }
}

.baiduQueue {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  // min-height: 940px;
  // display: flex;
  // flex-direction: column;
  .head {
    width: 100%;
    height: 470px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
    }

    .h0 {
      width: 1200px;
      z-index: 1;

      .h1 {
        font-size: 46px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #ffffff;
        margin-bottom: 58px;
        text-align: center;
      }

      .h2 {
        width: 922px;
        height: 78px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #ffffff;
        border-radius: 6px;
        margin: 0 auto;

        .h21 {
          padding-left: 30px;
          width: 80%;

          .el-input {
            width: 80%;
          }

          /deep/ .el-input__inner {
            border: none;

            font-size: 24px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #999999;
          }
        }

        .h22 {
          width: 208px;
          height: 78px;
          background: #ff5602;
          border-radius: 6px;
          text-align: center;
          line-height: 78px;
          font-size: 24px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          color: #ffffff;
        }
      }
    }
  }

  .b2 {
    width: 1200px;
    background: #FFFFFF;
    margin: 0 auto;
    min-height: 1000px;

    .b21 {
      display: flex;
      align-items: center;
      height: 60px;
      width: 100%;

      div {
        width: 20%;
        height: 60px;
        background: #F3F3F3;
        text-align: center;
        line-height: 60px;
        font-size: 20px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
      }

      .b211 {
        background: #FFFFFF;
        color: #198AFA;
      }

    }

    .b22 {
      padding-top: 30px;

      &>div {
        display: flex;
        align-items: center;
        width: 1200px;
        height: 120px;
        background: #FFFFFF;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        margin: 0 auto 20px;
        padding: 0 7px;

        img {
          width: 120px;
          height: 108px;
          margin-right: 32px;
        }

        &>div {
          width: calc(100% - 166px);

          .b221 {
            font-size: 24px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: #333333;
          }

          .b222 {
            font-size: 20px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #999999;
            margin-top: 14px;
          }
        }
      }
    }

    .b23 {
      padding-top: 30px;

      .b231 {
        display: flex;
        align-items: center;
        width: 1174px;
        height: 120px;
        background: #FFFFFF;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        margin: 0 auto 20px;
        padding: 0 13px;

        img {
          width: 97px;
          height: 98px;
          margin-right: 39px;
        }

        .b2311 {
          width: calc(100% - 300px);
          font-size: 24px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #333333;
        }

        .b2312 {
          width: 72px;
          height: 30px;
          border-radius: 15px;
          border: 1px solid #979797;
          text-align: center;
          line-height: 30px;
          cursor: pointer;

        }

        .b2313 {
          margin-right: 10px;
        }
      }

      .b232 {
        width: 128px;
        height: 48px;
        border-radius: 24px;
        border: 1px solid #CCCCCC;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
        margin-left: 447px;

        img {
          width: 25px;
          height: 20px;
        }

        div {
          font-size: 20px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #999999;
          margin-left: 6px;

        }
      }

    }

    .b25 {
      padding-top: 30px;

      img {
        width: 100%;
      }

      .web-url {
        padding: 20px;
        font-size: 20px;

        span {
          color: #333;
          font-weight: 500;
        }

        a {
          color: #198AFA;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    .b24 {
      padding-top: 30px;

      &>div {
        width: 494px;
        height: auto;
        background: #FFFFFF;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        padding: 16px 33px;
        margin: 0 auto;

        .b241 {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          img {
            width: 40px;
            height: 40px;
            margin-right: 17px;
          }

          div {
            font-size: 24px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 600;
            color: #333333;
          }
        }

        .b242 {
          font-size: 20px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }

  .label {
    width: 1200px;
    margin: 50px auto 30px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    height: 50px;
    overflow: hidden;
    transition: height 1s;

    .l1 {
      display: flex;
      flex-wrap: wrap;

      width: 95%;

      div {
        padding: 0 26px;
        height: 50px;
        background: #ffffff;
        border-radius: 33px;
        line-height: 50px;
        font-size: 20px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
        margin-right: 10px;
        margin-bottom: 10px;
        cursor: pointer;
      }

      .l11 {
        background: #198afa;
        color: #ffffff;
      }
    }

    .l2 {
      display: flex;
      align-items: center;
      height: 50px;
      cursor: pointer;

      div {
        font-size: 20px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
        margin-right: 6px;
      }

      img {
        width: 12px;
        height: 8px;
      }
    }
  }

  .label2 {
    height: auto;
    transition: height 1s;
  }

  .box {
    width: 1200px;

    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .b1 {
      width: 1200px;
      // padding: 0 11px;

      background: #ffffff;
      padding-top: 10px;
      padding-bottom: 30px;
      min-height: 940px;

      .b11 {
        height: 57px;
        line-height: 57px;
        text-align: center;
        font-size: 24px;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #999999;
        border-bottom: 1px solid #9797971f;
        margin-bottom: 30px;
      }

      .b12 {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        padding: 0 11px;

        &>div {
          width: 100px;
          height: 100px;
          background: #ffffff;
          box-shadow: 0px 0px 4px 0px #198afa;
          border-radius: 6px;
          margin-right: 14px;
          margin-bottom: 20px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        &>div:nth-child(5n) {
          margin-right: 0;
        }
      }
    }

    .b2 {
      width: 1200px;
      background: #ffffff;
      min-height: 1000px;

      .b21 {
        display: flex;
        align-items: center;
        height: 60px;
        width: 100%;

        div {
          width: 118px;
          height: 60px;
          background: #f3f3f3;
          text-align: center;
          line-height: 60px;
          font-size: 20px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #333333;
        }

        .b211 {
          background: #ffffff;
          color: #198afa;
        }
      }

      .b24 {
        padding-top: 30px;

        &>div {
          width: 1200px;
          height: auto;
          background: #ffffff;
          box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
          border-radius: 6px;
          padding: 16px 33px;
          margin: 0 auto;

          .b241 {
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            img {
              width: 40px;
              height: 40px;
              margin-right: 17px;
            }

            div {
              font-size: 24px;
              font-family: SourceHanSansCN-Medium, SourceHanSansCN;
              font-weight: 600;
              color: #333333;
            }
          }

          .b242 {
            font-size: 20px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #999999;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/brand/index.vue